import React, { useContext, useEffect } from 'react'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import { AuthContext } from '../contexts/AuthContext';

export const ProtectedRoute = ({children}: { children: any }) => {
    const { isAuth, user } = useContext<any>(AuthContext)
    let location = useLocation()
    let navigate = useNavigate()

    useEffect(() => {
      if (location.pathname != "/") {
        console.log(111, location.pathname.split("/")[1])
        if (location.pathname.split("/")[1] == "simcard" || location.pathname.split("/")[1] == "installationv2" || location.pathname.split("/")[1] == "sensor" || location.pathname.split("/")[1] == "application-board" || location.pathname.split("/")[1] == "pump" || location.pathname.split("/")[1] == "som-passed" || location.pathname.split("/")[1] == "app-board-passed") {
            if (user.role != "admin" && user.role != "engineer"  && user.role != "technician") {
                return navigate("/")
            }
        } else if (location.pathname.split("/")[1] == "pcba") {
            if (user.role != "admin" && user.role != "engineer"  && user.role != "technician" && user.role != "vendor-pcba") {
                return navigate("/")
            }
        } else if (location.pathname.split("/")[1] == "pump") {
            if (user.role != "admin" && user.role != "engineer"  && user.role != "technician" && user.role != "vendor-pump") {
                return navigate("/")
            }
        } else if (location.pathname.split("/")[1] == "customer" && location.pathname.split("/")[1] == "component" && location.pathname.split("/")[1] == "node" || location.pathname.split("/")[1] == "telemetry" || location.pathname.split("/")[1] == "remote-reset") {
            if (user.role != "admin" && user.role != "engineer") {
                return navigate("/")
            }
        } else if (location.pathname.split("/")[1] == "create-serial" && location.pathname.split("/")[1] == "download-content" ) {
            if (user.role != "admin" && user.role != "technician") {
                return navigate("/")
            }
        } else {
            return navigate("/")
        }
      }
    }, [])
    
    return isAuth ? (
        <>
        <Header/>
        <Sidebar/>
        {children}
        <Footer/>
        </>
    ) : <Navigate to="/login" />;
}
